import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
// import { Reveal } from "react-awesome-reveal";
// import { keyframes } from "@emotion/react";
// import { Icon } from "@iconify/react";
// import { isDesktop } from "react-device-detect";

// import { Modal } from "react-responsive-modal";
import QuotaDeposit from "./QuotaDeposit";
import DepositHistory from "./DepositHistory";
// import SideBar from "../../components/Sidebar/Sidebar";
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";

import { Accordion, TabContainer, Nav, NavItem, NavLink, TabContent, TabPane } from 'react-bootstrap'

class MobileDelegateDeposit extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = {
            pageShow: "quota_deposit",
            showModal: false,
            filterShow: '',
        };
    }

    showDateHandler = () => 
    {
        this.setState({
            filterShow: 'date'
        })
    }

    
    offDateHandler = () => 
    {
        this.setState({
            filterShow: ''
        })
    }

    toggleModal = () => 
    {
        this.setState({
            showModal: !this.state.showModal,
        });
    };

    render() 
    {
        const { t } = this.props;
        return (
            <>
                <section className="pf-m-dashboard">
                {/* <div className="filters-m-col show">
                    <MobileSubHeader
                        className="bg-white"
                        returnPage="/"
                        header="Delegate Deposit"
                        modalHeader={true}
                        modalHandler={this.props.toggleModal}
                    />
                    </div> */}
                    <TabContainer defaultActiveKey="quota_deposit">
                        <div className={`filters-m-col ${this.state.filterShow ? 'show' : ''}`} >
                            <MobileSubHeader
                                className="bg-white"
                                returnPage="/"
                                header={t('sidebar.delegate-deposit')}
                                modalHeader={true}
                                modalHandler={this.props.toggleModal}
                            />
                            <div className="delegate-deposit-wrap">
                                <Nav className='mobile delegate-deposit-nav' variant="pills">
                                    <NavItem>
                                        <NavLink eventKey="quota_deposit" id="quota_deposit" >{t('delegate-deposit.quota-deposit')}</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink eventKey="deposit_history" id="deposit_history" >{t('delegate-deposit.deposit-history')}</NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                        </div>
                        <TabContent className='tab-content-container'>
                            <TabPane eventKey="quota_deposit">
                                <QuotaDeposit redirectHandler={this.props.redirectHandler}/>
                            </TabPane>
                            <TabPane eventKey="deposit_history">
                                <DepositHistory 
                                    {...this.state}
                                    {...this.props}
                                    showDateHandler={this.showDateHandler}
                                    offDateHandler={this.offDateHandler}
                                />
                            </TabPane>
                        </TabContent>
                    </TabContainer>
                    
                </section>
            </>
        )
    }
}

export default withNamespaces("translation")(MobileDelegateDeposit);